var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DetailRichText"},[_c('div',{staticClass:"title"},[_vm._v("更多内容")]),_c('div',{staticClass:"content",attrs:{"id":"detail-content"},domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }